
// package imports
import { Col, Row } from "react-bootstrap"
// project imports
import "./pasa-life-assured-details-card.css"
import PasaProposerDetailsCard from "../pasa-proposer-details-card/PasaProposerDetailsCard"

const PasaLifeAssuredDetailsCard = (props) => {
    const { LADetails } = props
    return (
        <>
            {LADetails.all_journey_list.map((item, index) => (
                <>
                    <Row className="pasa-card mb-4 mx-0">
                        <Col className=" col-12 col-md-2 la-card-pasa font-size-13 mb-3 mb-md-0">
                            <div>
                                <p className='font-size-12 mb-0 text-primary'>Life Assured Name</p>
                                <div className="border my-1 w-100 font-size-13 text-center">{item.la_name} </div>
                            </div>
                        </Col>

                        <Col className="col-12 col-md-10">
                            {item.journey_list.length > 1 ?
                                item.journey_list.map((data, index) => {
                                    return (
                                        <>
                                            <div className={`pasa-child`}>
                                                <PasaProposerDetailsCard
                                                    proposerData={data}
                                                />
                                                {item.journey_list.length !== index + 1 && (
                                                    <hr className='my-2 hr-pasa' ></hr>
                                                )}
                                            </div>
                                        </>
                                    )
                                })
                                :
                                <div className={`pasa-child`}>
                                    <PasaProposerDetailsCard
                                        proposerData={item.journey_list[0]}
                                    />
                                </div>
                            }
                        </Col>
                       
                    </Row>
                 
                        
                 
                </>
            ))}
        </>
    )
}
export default PasaLifeAssuredDetailsCard;
